import { render, staticRenderFns } from "./JdNews.vue?vue&type=template&id=45c1e80c&scoped=true"
import script from "./JdNews.vue?vue&type=script&lang=js"
export * from "./JdNews.vue?vue&type=script&lang=js"
import style0 from "./JdNews.vue?vue&type=style&index=0&id=45c1e80c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c1e80c",
  null
  
)

export default component.exports